"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var BulkProductsService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProfileService class.
     * @param http
     * @param config
     */
    function BulkProductsService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Adjust Dates Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.AdjustDatesAsync = function (deliverableIds, adjustDatesRequest) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/adjustdates", adjustDatesRequest, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Adjust Phase Dates Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.AdjustPhaseDatesAsync = function (deliverableIds, adjustDatesRequest) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/adjustphasedates", adjustDatesRequest, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Allocate Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.AllocateAsync = function (deliverableIds, newOwnerId) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        params = params.set('newOwnerId', newOwnerId.toString());
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/allocate", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Confirm Schedule Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.ConfirmScheduleAsync = function (deliverableIds, request) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/confirmschedule", request, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Start Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.StartAsync = function (deliverableIds, startedDate) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        if (startedDate)
            params = params.set('startedDate', startedDate);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/start", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Start Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.CompleteAsync = function (deliverableIds, completedDate, completionNotes) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        if (completedDate)
            params = params.set('completedDate', completedDate);
        if (completionNotes)
            params = params.set('completionNotes', completionNotes);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/complete", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Poke Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.PokeAsync = function (deliverableIds, comment) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        if (comment)
            params = params.set('comment', comment);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/poke", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Reset Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BulkProductsService.prototype.ResetAsync = function (deliverableIds) {
        var params = new http_1.HttpParams();
        var ids = deliverableIds.join(",");
        params = params.set('deliverableids', ids);
        return this.http.post(this.config.DeliverablesApiURL + "/api/bulkproducts/reset", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    BulkProductsService.ngInjectableDef = i0.defineInjectable({ factory: function BulkProductsService_Factory() { return new BulkProductsService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: BulkProductsService, providedIn: "root" });
    BulkProductsService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], BulkProductsService);
BulkProductsService.ɵfac = function BulkProductsService_Factory(t) { return new (t || BulkProductsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
BulkProductsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BulkProductsService, factory: function (t) { return BulkProductsService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BulkProductsService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return BulkProductsService;
}());
exports.BulkProductsService = BulkProductsService;

